import { BaseRestDataProvider } from './data/BaseRestDataProvider';

// Auth is JWT-based. MSAL loginPopup also stores its token via BaseRestDataProvider.setToken(),
// so a single token presence check covers both local and Entra login paths.
export function isLoggedIn(): boolean {
  return !!BaseRestDataProvider.getToken();
}

export function logout() {
  BaseRestDataProvider.clearToken();
  window.location.reload();
}
